import React from 'react'
import { ParagraphSM } from '@/atoms/Text'

interface RuleSubsectionProps {
  title: string
  rules: string[]
}

export const RuleSubsection: React.FC<RuleSubsectionProps> = ({ title, rules }) => {
  return (
    <div className="mt-4">
      <ParagraphSM weight="bold" color="core-gray-400" className="mb-2">
        {title}
      </ParagraphSM>
      <ul className="space-y-2 pl-3">
        {rules.map((rule, index) => (
          <li key={index} className="flex items-start">
            <span className="mr-3 mt-2 h-1 w-1 shrink-0 rounded-full bg-core-gray-400"></span>
            <ParagraphSM weight="normal" color="core-gray-400" className="leading-relaxed">
              {rule}
            </ParagraphSM>
          </li>
        ))}
      </ul>
    </div>
  )
}
